// TermsOfService.jsx
import React from 'react';
import Image from "../public/ai-generated-assortment-of-african-traditional-dishes-african-food-free-photo.jpg";
import Logo from "../public/AfricFreshLogo-01.svg";
import { Link } from 'react-router-dom';
import Footer from '../components/footer';

const TermsOfService = () => {
  return (
    <div className="w-full min-h-screen flex flex-col">
      {/* Header */}
      <div className='flex justify-center items-center py-5'>
        <Link to="/">
          <img src={Logo} alt="AfricFresh Logo" className='w-[200px]' />
        </Link>
      </div>

      {/* Hero Banner */}
      <div className="relative h-[300px] w-full">
        <div 
          className="absolute inset-0 bg-cover bg-center before:content-[''] before:absolute before:inset-0 before:bg-black before:opacity-50"
          style={{
            backgroundImage: `url(${Image})`,
          }}
        />
        <div className="absolute inset-0 flex items-center">
          <h1 className="text-white text-5xl md:text-6xl font-serif px-4 text-center">
            Terms of Service
          </h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-6 py-12 bg-[#fdf7f7] flex-grow">
        <h2 className="text-2xl font-bold text-[#333333] mb-6">
          Terms of Service for AfricFresh
        </h2>

        {/* Introduction */}
        <div className="space-y-8 text-gray-700">
          <p className="leading-relaxed">
            Welcome to AfricFresh. By using our website and services, you agree to comply with and be bound by the following Terms of Service. Please read these terms carefully before using our site or making any purchases.
          </p>

          {/* Terms Sections */}
          <section className="space-y-8">
            {/* Section 1 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">1. Acceptance of Terms</h3>
              <p className="leading-relaxed">
                By accessing and using AfricFresh, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our website or services.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">2. Use of Our Website</h3>
              <p className="leading-relaxed">
                You agree to use our website for lawful purposes only. You are prohibited from using our website in any manner that could damage, disable, overburden, or impair the functionality of the site, or interfere with any other party's use of the website.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">3. Account Registration</h3>
              <p className="leading-relaxed">
                To make a purchase or access certain services on our site, you may be required to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities under your account. You must notify us immediately of any unauthorized use of your account.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">4. Product Information and Availability</h3>
              <p className="leading-relaxed">
                We make every effort to provide accurate descriptions and pricing for the products listed on our website. However, we do not guarantee the availability or accuracy of any product information. Prices and availability are subject to change without notice.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">5. Ordering and Payment</h3>
              <p className="leading-relaxed">
                By placing an order on AfricFresh, you are offering to purchase a product subject to acceptance by us. All payments must be made through our approved payment methods. We reserve the right to cancel or refuse an order for any reason, including issues with payment processing or product availability.
              </p>
            </div>

            {/* Sections 6-12 following the same pattern */}
            {/* Add sections 6-12 here with the same formatting */}

            {/* Closing Statement */}
            <div className="pt-6 border-t border-gray-200">
              <p className="font-medium">
                By using AfricFresh, you acknowledge that you have read, understood, and agreed to be bound by these Terms of Service.
              </p>
            </div>
          </section>
        </div>
      </div>

      {/* Portal Icon */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow cursor-pointer">
          <svg 
            className="w-8 h-8 text-[#007D44]" 
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16z" />
          </svg>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfService;